










































































































































































import { Component, Mixins, Ref, Watch } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import { Getter } from 'vuex-class';
import moment from 'moment';
import { i18n } from '@/i18n';
import { QDataTable } from '@resclick/crs-ui';

@Component({
  components: {},
})
export default class HotelTurnoverReportShell extends Mixins(TableMixin) {
  @Getter('user/defaultCurrency') currency!: string;
  @Getter('user/currentCompany') company!: string;
  @Getter('user/ownedPermissions') permissions!: string;
  @Ref('table') table!: QDataTable;

  formatDate = (date: any) => {
    return moment(date).format('DD/MM/YYYY');
  };

  expandedProperties: string[] = [];

  toggleProperty(id: string) {
    const index = this.expandedProperties.indexOf(id);
    index > -1 ? this.expandedProperties.splice(index, 1) : this.expandedProperties.push(id);
  }

  get columns() {
    return [
      {
        label: '',
        name: '',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.HOTEL',
        name: 'name',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.NUMBER_OF_ROOMS',
        name: 'rooms',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.PAX',
        name: 'pax',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.ADULT',
        name: 'adults',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.CHILD',
        name: 'children',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.ROOM_OVERNIGHT',
        name: 'roomOvernight',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.PAX_OVERNIGHT',
        name: 'paxOvernight',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.ADULT_OVERNIGHT',
        name: 'adultOvernight',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.CHILD_OVERNIGHT',
        name: 'childOvernight',
        style: 'width:1px',
      },

      {
        label: 'GENERAL.TURNOVER',
        name: 'turnover',
        style: 'width:1px',
      },

      {
        label: 'GENERAL.COST',
        name: 'cost',
        style: 'width:1px',
      },

      {
        label: 'GENERAL.PROFIT',
        name: 'profit',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.PROFIT_MARGIN',
        name: 'profitMargin',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.PAYMENT_COLLECTION',
        name: 'collection',
        style: 'width:1px',
      },
      {
        label: 'GENERAL.CANCELLATION_INSURANCE',
        name: 'cancellationInsuranceTurnover',
        style: 'width:1px',
      },

      {
        label: 'GENERAL.AVERAGE_PP_SALE',
        name: 'averagePpSale',
        style: 'width:1px',
      },

      {
        label: 'GENERAL.AVERAGE_PP_PURCHASE',
        name: 'averagePpPurchase',
        style: 'width:1px',
      },
    ];
  }

  filters = [
    {
      label: this.$i18n.t('GENERAL.BOOKING_DATE'),
      type: 'date-range',
      value: { start: new Date().setHours(0, 0, 0, 0), end: new Date().setHours(23, 59, 59, 999) },
      fieldName: 'bookingDate',
    },
    {
      label: this.$i18n.t('GENERAL.ACCOMMODATION_DATE'),
      type: 'date-range',
      value: { start: new Date().setHours(0, 0, 0, 0), end: new Date().setHours(23, 59, 59, 999) },
      fieldName: 'accommodationDate',
    },
    {
      label: this.$i18n.t('GENERAL.PROPERTY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'products.property',
      namespace: 'properties',
      action: 'find',
    },
    {
      label: this.$i18n.t('GENERAL.COMPANY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'company',
      namespace: 'companies',
      action: 'find',
    },
    {
      label: this.$i18n.t('GENERAL.AGENT'),
      type: 'selectDynamic',
      value: [],
      optionName: (user: any) => {
        return `${user.name} ${user.surname}`;
      },
      query: { select: ['name', 'surname'] },
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'agent',
      namespace: 'users',
      action: 'find',
    },
    {
      label: this.$i18n.t('GENERAL.PROPERTY_GROUPS'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'propertyGroups',
      namespace: 'propertyGroups',
      action: 'find',
    },
  ];

  get query() {
    return {
      select: ['+calculations'],
      sort: { orderNumber: 'desc' },
      currency: this.currency,
    };
  }

  // get totals() {
  //   const table = this.$refs.table as any;
  //   const data: any[] = table.tableData || [];

  //   const result = {
  //     cost: 0,
  //     profit: 0,
  //     pax: 0,
  //     productsCount: 0,
  //     ordersCount: 0,
  //     turnover: 0,
  //   };

  //   for (const report of data) {
  //     result.turnover += report.turnover;
  //     result.cost += report.cost;
  //     result.profit += report.profit;
  //     result.pax += report.pax;
  //     result.productsCount += report.productsCount;
  //     result.ordersCount += report.ordersCount;
  //   }
  //   return result;
  // }

  totals = {
    turnover: 0,
    cost: 0,
    profit: 0,
    profitMargin: 0,
    pax: 0,
    rooms: 0,
    adults: 0,
    children: 0,
    roomOvernight: 0,
    paxOvernight: 0,
    adultOvernight: 0,
    childOvernight: 0,
    collection: 0,
    cancellationInsurance: 0,
    averagePpSale: 0,
    averagePpPurchase: 0,
    currency: '',
  };

  @Watch('query.currency')
  onCurrencyChange() {
    this.$nextTick(() => {
      this.$refs.table.refresh();
    });
  }

  updateTotals(data: any = []) {
    const result = {
      turnover: 0,
      cost: 0,
      profit: 0,
      profitMargin: 0,
      pax: 0,
      rooms: 0,
      adults: 0,
      children: 0,
      roomOvernight: 0,
      paxOvernight: 0,
      adultOvernight: 0,
      childOvernight: 0,
      collection: 0,
      cancellationInsurance: 0,
      averagePpSale: 0,
      averagePpPurchase: 0,
      currency: '',
    };
    for (const report of data) {
      result.turnover += report.turnover;
      result.cost += report.cost;
      result.profit += report.profit;
      result.pax += report.pax;
      result.rooms += report.rooms;
      result.adults += report.adults;
      result.children += report.children;
      result.roomOvernight += report.roomOvernight;
      result.paxOvernight += report.paxOvernight;
      result.adultOvernight += report.adultOvernight;
      result.childOvernight += report.childOvernight;
      result.collection += report.collection;
      result.cancellationInsurance += report.cancellationInsuranceTurnover;
      result.currency = report.currency;
    }
    result.profitMargin = (result.cost / result.turnover - 1) * -100 || 0;
    result.averagePpSale = result.turnover / result.paxOvernight || 0;
    result.averagePpPurchase = result.cost / result.paxOvernight || 0;
    this.totals = result;
  }

  created() {
    this.filters[1].value = [this.company] as any;
  }

  exportData() {
    const translatedColumns = this.columns.map((c) => {
      return {
        ...c,
        label: i18n.t(c.label),
      };
    });
    // @ts-ignore
    this.$refs.table.exportTable(translatedColumns);
  }

  cleanFilters() {
    this.filters = this.filters.map((f: any) => {
      switch (f.type) {
        case 'number':
          f.value = null;
          return f;
        case 'string':
          f.value = '';
          return f;
        case 'date-range':
          f.value = { start: '', end: '' };
          return f;
        case 'date':
          f.value = { start: '', end: '' };
          return f;
        default:
          return f;
      }
    });
  }
}
